<template>
  <div
    :class="[ns.b('group'), ns.is('vertical', isVertical)]"
    :style="groupStyle"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { provide, reactive, toRef, computed } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { buttonGroupProps } from './button-group'
import { buttonGroupContextKey } from './constants'

defineOptions({
  name: 'JdButtonGroup',
})
const props = defineProps(buttonGroupProps)
const isVertical = computed(() => props.direction === 'vertical')
const groupStyle = computed(() => {
  if (isVertical.value) {
    return {
      gap: `${props.spacing}px`,
    }
  }
  return {}
})

provide(
  buttonGroupContextKey,
  reactive({
    size: toRef(props, 'size'),
    type: toRef(props, 'type'),
  })
)
const ns = useNamespace('button')
</script>
